import axios from "axios";
import { useEffect, useState } from "react";
import { API_BASE_PATH } from "./Api";
import {MapDataView} from "./Maplayout";


import './tw.css';





export default function SearchComponent({ onsearch }) {

  const [st, setSt] = useState("");
  return (
    <div className="flex items-center">
      <div className="flex space-x-1">
        <input
          type="text"
          className="block w-full px-4 py-2 text-black-700 bg-white border rounded-full focus:border-black-400 focus:ring-black-300 focus:outline-none focus:ring focus:ring-opacity-40"
          placeholder="Search..."
          value={st}
          onChange={e => setSt(e.target.value)}

        />
        <button className="px-4 text-white bg-blue-600 rounded-full " onClick={e => onsearch(st)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}


const OutletInfo = ({ similarityInfo }) => {
  return (
    <div className="relative min-w-screen  flex items-center justify-center px-1 py-1">

      <div className="rounded shadow-xl overflow-hidden w-full md:flex" style={{ maxWidth: '500px' }}>



        <div className="flex w-full md:w-1/1 p-3 bg-gray-100 text-gray-600 items-center">
          <div className="w-full">
            <h3 className="text-lg font-semibold leading-tight text-gray-800">
              <span>Outletcode</span>
                              &nbsp;&nbsp;-&nbsp;&nbsp;{similarityInfo.outletcode}
            </h3>

            <h6 className="text-sm leading-tight mb-2">
              <span>Matched outlets</span>
                              &nbsp;&nbsp;-&nbsp;&nbsp;{similarityInfo.payload.data.split(",").length}
            </h6>


          </div>
        </div>
      </div>


    </div>

  );
}

const OutletMatchInfo = ({ tv }) => {
  return (
    <div className="relative min-w-screen    flex items-center justify-center px-5 py-1">

      <div className="rounded shadow-xl overflow-hidden w-full md:flex" style={{ maxWidth: '900px' }}>



        <div className="flex w-full md:w-1/1 p-3 bg-gray-100 text-gray-600 items-center">
          <div className="w-full">
            <h3 className="text-lg font-semibold leading-tight text-gray-800">{tv[0]}</h3>
            {/* <h6 className="text-sm leading-tight mb-2">
                              <span>Confidence Score</span>
                              &nbsp;&nbsp;-&nbsp;&nbsp;Aug 2nd 4:10pm AEST
                          </h6> */}
            <div className="flex w-full items-end mb-6">
              <span className="block leading-none text-3xl text-gray-800">{(+tv[5] * 100).toFixed(0)}</span>
              <span className={`block leading-5 text-sm ml-4 text-${+tv[5] * 100 < 70 ? 'red' : 'green'}-200`} style={{color:`${+tv[5] * 100 < 70 ? 'red' : 'green'}`}}>
                {`Confidence Score  ${+tv[5] * 100 < 70 ? '▼' : '▲'} `}
              </span>
            </div>
            <div className="flex w-full text-xs">
              <div className="flex w-5/12">
                <div className="flex-1 pr-3 text-left font-semibold">Channel</div>
                <div className="flex-1 px-3 text-right">true</div>
              </div>
              <div className="flex w-7/12">
                <div className="flex-1 px-3 text-left font-semibold">SKU Mix Score</div>
                <div className="flex-1 pl-3 text-right">{tv[3]}</div>
              </div>
            </div>
            <div className="flex w-full text-xs">
              <div className="flex w-5/12">
                <div className="flex-1 pr-3 text-left font-semibold">User Group</div>
                <div className="px-3 text-right">true</div>
              </div>
              <div className="flex w-7/12">
                <div className="flex-1 px-3 text-left font-semibold">Outlet Capacity Match</div>
                <div className="pl-3 text-right">{tv[4]}</div>
              </div>
            </div>
            {/* <div className="flex w-full text-xs">
                              <div className="flex w-5/12">
                                  <div className="flex-1 pr-3 text-left font-semibold">Confidence Score</div>
                                  <div className="px-3 text-right">60</div>
                              </div>
                               <div className="flex w-7/12">
                                  <div className="flex-1 px-3 text-left font-semibold">Dividend yield</div>
                                  <div className="pl-3 text-right">{`${info.price.dividend}%`}</div>
                              </div> 
                          </div> */}
          </div>
        </div>
      </div>


    </div>

  );
}


const OutletMatchList = ({ similarityInfo }) => {
  return (
    <>

      {
        similarityInfo.payload.data.split(",").map((v, i) => {

          const tv = v.split(":");
          return <OutletMatchInfo tv={tv} />

        })
      }
    </>
  );
}
export const OutletSimilarity = ({ outletCode = '' }) => {

  let [similarityInfo, setSimilarityInfo] = useState(null);
  var userInfo = localStorage.getItem("userInfo");
  if(userInfo){
    userInfo = JSON.parse(userInfo);
  }
  useEffect(() => {

    if(outletCode)
    onsearch(outletCode);
    

  }, [outletCode])

  const onsearch = (oc) => {
    setSimilarityInfo(null);
    if(oc){
    //axios.get("http://localhost:9111" + `/similarity/${oc}?lob=${userInfo.accountId}`)
    axios.get(API_BASE_PATH + `/similarity/${oc}?lob=${userInfo.accountId}`)

      .then(response => {
        const data = response.data;
        setSimilarityInfo(data[0])
      })
      .catch(error => {
        console.log(error);
      })
    }

    
  }


  return (
    <div style={{ paddingTop: "100px" }}>
      <div className=" flex justify-center " >
        <SearchComponent onsearch={onsearch} />

      </div>


      { similarityInfo &&
        <div className=" mx-auto bg-gray-200 rounded-xl shadow border p-8 m-10" >



          <div class="relative flex min-h-screen flex-col justify-center overflow-hidden bg-gray-50 py-6 sm:py-12">
            <img src="img/beams.jpg" alt="" class="absolute top-1/2 left-1/2 max-w-none -translate-x-1/2 -translate-y-1/2" width="1308" />
            <div class="absolute inset-0 bg-[url(img/grid.svg)] bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))]"></div>

            <OutletInfo similarityInfo={similarityInfo} />

            <div className="flex md:inline-flex min-w-screen">
              <div className="w-2/4">


                <OutletMatchList similarityInfo={similarityInfo} />

                {/* <div className="relative min-w-screen    flex items-center justify-center px-5 py-1">
      <StockChart info={data} />
    </div>
    <div className="relative min-w-screen    flex items-center justify-center px-5 py-1">
      <StockChart info={data} />
    </div> */}
              </div>
              <div className="w-2/4" >
                  {
                    similarityInfo.payload.location && similarityInfo.payload.location[0]!=0 && 
                    <div class="relative bg-white  shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:rounded-lg p-3" style={{height:"100vh"}}>

                    <MapDataView similarityInfo={similarityInfo} />
                    </div>

                  }

                  {
                    !(similarityInfo.payload.location && similarityInfo.payload.location[0]!=0) &&
                    <div class="relative bg-white px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10">
                    <div class="mx-auto max-w-md">
                      <img style={{width:"auto",height:"100px"}} src="img/map_info.png" class="h-6" alt="Tailwind Play" />
                      <div class="divide-y divide-gray-300/50">
                        <div class="space-y-6 py-8 text-base leading-7 text-gray-600">
                          <p>No geo coordinates for {similarityInfo.outletcode}</p>
                          
                          <p>Check outlet master data to ensure corrdinates are received from constomer</p>
                        </div>
                        <div class="pt-8 text-base font-semibold leading-7">
                          <p class="text-gray-900">Want to learn more about this</p>
                          <p>
                            <a href="" class="text-sky-500 hover:text-sky-600">Read the docs &rarr;</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                

//                     https://www.bolddesk.com/wp-content/uploads/2022/09/freshdesh-card-bakcground-v3.svg
//                     <div class="relative bg-white  shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:rounded-lg p-10 justify-center flex" style={{height:"100vh",alignItems:"center"}}>
// <img
//                 className="object-cover w-full lg:w-40 lg:h-40"
//                 src="https://www.howtogeek.com/wp-content/uploads/2022/08/Google-Maps-icon-on-map.png?width=1198&trim=1,1&bg-color=000&pad=1,1"
//                 alt="image"
//             />

// <h4 className="text-xl font-semibold tracking-tight text-blue-600">
//                 No geo coordinates for {similarityInfo.outletcode}
//                 </h4>

// </div>

                  }
                  
                </div>


            </div>


          </div>



        </div>
      }
    </div>

  );


}
